import type { CourseModule } from "@/core/types";
import { lektionFussnoten } from "./lektion-01-fussnoten";
import { lektionBeschriftungen } from "./lektion-02-beschriftungen";
import { lektionQuerverweise } from "./lektion-03-querverweise";
import { lektionStichwortverzeichnis } from "./lektion-04-stichwortverzeichnis";
import { lektionVerweiseAbschluss } from "./lektion-05-abschluss";

export const modulVerweise: CourseModule = {
  id: "verweise",
  title: "Verzeichnisse und Verweise",
  summary:
    "Fußnoten, Beschriftungen, Abbildungsverzeichnis und Querverweise – alles " +
    "als Felder, die sich selbst auf dem Laufenden halten.",
  level: "Aufbau",
  lessons: [
    lektionFussnoten,
    lektionBeschriftungen,
    lektionQuerverweise,
    lektionStichwortverzeichnis,
    lektionVerweiseAbschluss,
  ],
};
